<div id="map"></div>
<rota-basemap class="hide-on-mobile"></rota-basemap>

<div id="snackbar-container" class="open" [hidden]="!controlStatus.carregando">
    <div class="snackbar">
        <span>  <img src="assets/img/loading.gif" alt="loading"> Carregando Informações </span>
    </div>
</div>

<div class="legenda hide-on-mobile">
    <div class="icone" (mouseenter)="mostrarTabela = true" (mouseleave)="mostrarTabela = false">
        <button class="botao_legenda"> <i class="fa fa-info"></i></button>
      </div>
      
      <div class="table" style="display: flex;" *ngIf="mostrarTabela">
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                  <th scope="col" colspan="2" style="text-align: center;background-color: rgb(47,48,52);color: white;">
                    Status da Entrega</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                    <td class="sigla-info"><img class="icones_legenda" [src]="entregaIniciadaURL"/>Entrega iniciada</td>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icones_legenda" [src]="emAbertoURL"/>Não visitado</td>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icones_legenda" [src]="voltoDepoisURL"/>Volto depois</td>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icones_legenda" [src]="comOcorrenciaURL"/>Com Ocorrencia</td>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icones_legenda" [src]="riscoAlagamento"/>Risco de Alagamento</td>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icones_legenda" [src]="noClienteURL"/>No cliente</td>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icones_legenda" [src]="entregaParcialURL"/>Entrega parcial</td>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icones_legenda" [src]="riscoFurtoRoubo"/>Risco de Furto/Roubo</td>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icones_legenda" [src]="entregueURL"/>Entregue</td>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icones_legenda" [src]="naoEntregueURL"/>Não entregue</td>
                </tr>
                <tr>
                    <td class="sigla-info"> <img class="icones_legenda" [src]="alertaDuploURL"/>Parcial com ocorrência</td>
                </tr>
                <tr>
                    <th scope="col" colspan="2" style="text-align: center;background-color: rgb(47,48,52);color: white;">
                      Pontos de Rota</th>
                </tr>
                <tr>
                    <td class="sigla-info"><span class="ponto-de-rota verde"></span>Até 10 minutos</td>
                </tr>
                <tr>
                    <td class="sigla-info"><span class="ponto-de-rota amarelo"></span>Até 30 minutos</td>
                </tr>
                <tr>
                    <td class="sigla-info"><span class="ponto-de-rota vermelho"></span>Mais que 30 minutos</td>
                </tr>
                <tr>
                  <td class="sigla-info"><span class="ponto-de-rota alerta"></span>Alerta de monitoramento</td>
              </tr>
                <tr>
                    <th scope="col" colspan="2" style="text-align: center;background-color: rgb(47,48,52);color: white;">
                        Traçado da Rota</th>
                </tr>
                <tr>
                    <td class="sigla-info"><span class="tracado-da-rota percorrido"></span>Roteiro percorrido</td>
                </tr>
                <tr>
                    <td class="sigla-info"><span class="tracado-da-rota planejado"></span>Roteiro planejado</td>
                </tr>
                <tr>
                    <td class="sigla-info"><span class="tracado-da-rota ponto-fixo"></span>Roteiro pontos fixos</td>
                </tr>
                <tr>
                    <td class="sigla-info"><span class="tracado-dash"></span>Sem coleta de coordenada</td>
                </tr>
                <tr>
                    <td class="sigla-info"><span class="ponto-de-rota azul"></span>Passo do ajudante</td>
                </tr>
                <tr>
                    <th scope="col" colspan="2" style="text-align: center;background-color: rgb(47,48,52);color: white;">
                      Barreira</th>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icone-barreira" src="assets/img/pointBarrier.png" alt="">Ponto de bloqueio</td>
                </tr>
                <tr>
                    <td class="sigla-info"><span class="tracado-da-rota tracado-pedagio"></span>Barreira</td>
                </tr>
                <tr>
                    <td class="sigla-info"><img class="icone-barreira" src="assets/img/cerca-eletronica-icon.png" alt="">Cerca eletrônica</td>
                </tr>
            </tbody>
        </table>
      </div>
</div>
